"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
// import { useSelectedLayoutSegments } from "next/navigation";
import { directories } from "@/scripts/data";

const siteMap=JSON.parse(JSON.stringify(directories));

export default function Breadcrumb({data}) {

  const pathname = usePathname();
  // const segments = useSelectedLayoutSegments();
  const [breadcrumbs, set_breadcrumbs] = useState([]);

  useEffect(()=>{
    data.posts.forEach((item)=>{
      siteMap.push({
        title: `${item.title}`,
        url: `/news/article/${item.id}/`,
      });
    })
    data.categories.forEach((item)=>{
      siteMap.push({
        title: `${item.title}`,
        url: `/news/${item.slug}/`,
      });
    })
    data.tags.forEach((item)=>{
      siteMap.push({
        title: `${item.title}`,
        url: `/news/implementation/${item.slug}/`,
      });
    })
  },[]);

  useEffect(() => {
    const slugs = pathname.split("/").filter((item) => item.length > 0);
    // console.log(segments,slugs);
    const pathNames = [...slugs.map((slug, i) => {
      return `/${slugs.slice(0,i+1).join("/")}/`
      // return (i == 0 ? `/${slug}/` : `/${slugs[0]}/${slug}/`)
    })];

    const _breadcrumbs = siteMap.filter((item) => pathNames.find((slug) => item.url == slug));
    set_breadcrumbs(_breadcrumbs);
  }, [pathname]);

  return (
    <div className="breadcrumbs-list container-m">
      <div className="breadcrumbs-item home">
        <Link className="breadcrumbs-link scaleHover opacity" href="/">
          <div className="inner">Home</div>
        </Link>
      </div>
      {breadcrumbs.map((item, i) => (
        <div className="breadcrumbs-item" key={i}>
          <div className="dot"></div>
          <Link className={`breadcrumbs-link scaleHover opacity ${pathname == item.url ? "current" : ""}`} href={item.url}>
            <div className="inner">{item.title}</div>
          </Link>
        </div>
      ))}
    </div>
  );
}
